import {fetchGet, fetchPost, fetchPut} from '@/fetch/api'

export const getConfigInfo = () => {
    return fetchGet("/system/web/tenant/config/info");
}
